export default function creditCardExpInputDirective() {
  'ngInject';
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function ($scope, $element, $attrs, ctrl) {
      ctrl.$validators.expiration = function (modelValue) {
        if(modelValue) {
          let date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth(),
            userSplit = modelValue.split('/'),
            userYear = parseInt("20" + userSplit[1]),
            userMonth = parseInt(userSplit[0]);
          return userYear < year || (year === userYear && userMonth < month) ? false : true;
        }
      };

    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/creditCardExpInput.directive.js
 **/